import axios from 'axios';

import { EMPLOYMENT_AGENCIES } from 'RestAPIs/endpoints';

export interface EmploymentAgenciesValues {
  id: number;
  name: string;
}

export const getEmploymentAgenciesValues = ({
  startDate,
  endDate
}: {
  startDate: string;
  endDate?: string;
}) => {
  return axios.get<EmploymentAgenciesValues[]>(EMPLOYMENT_AGENCIES, {
    params: {
      startDate,
      endDate
    }
  });
};
